import React, {useState, useRef} from 'react'
import PPAListComponent from '../../components/Ppa/PpaList';
import SubHeader from '../../components/Subheader/Subheader';
import { useSelector } from 'react-redux';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import Spinner from '../../components/Tools/spinner';
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));


export default function Ppa() {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');
    /** L2 only: 'all' | 'pending' — passed to PPA list for client-side filter */
    const [approvalView, setApprovalView] = useState('all');

    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setDateColumn(dateColumn);
        setToSearchStr(searchStr);
    };
    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>PPA</h4>
                    <CustomBreadcrumbs linksArray={[]} title="PPA"/>
                </div>
                <div className="col-md-6">
                    <div className="m-0 p-0 d-flex gap-2 align-items-center justify-content-end flex-wrap" style={{ width: "auto", float: "right" }}>
                        {String(authData?.user?.user_type || '').toLowerCase() === 'l2' && (
                            <div
                                className="d-flex align-items-center gap-2 bg-white px-3 py-2 rounded-3"
                                style={{
                                    border: "1px solid rgba(40, 49, 111, 0.20)",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                                }}
                            >
                                <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                                    <p
                                        className={`m-0 fs-14px fw-500 ${
                                            approvalView === "all" ? "text-secondary-100" : "text-black-50"
                                        }`}
                                    >
                                        All
                                    </p>
                                    <AntSwitch
                                        checked={approvalView === 'pending'}
                                        onChange={(e) =>
                                            setApprovalView(e.target.checked ? 'pending' : 'all')
                                        }
                                        sx={{ mx: 0.75 }}
                                        inputProps={{
                                            'aria-label':
                                                'Toggle between all PPA rows and pending for approval',
                                        }}
                                    />
                                    <p
                                        className={`m-0 fs-14px fw-500 ${
                                            approvalView === "pending" ? "text-secondary-100" : "text-black-50"
                                        }`}
                                    > Pending
                                    </p>
                                </Stack>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='scheme p-2'>
                <PPAListComponent fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr} setLoading={setLoading} approvalView={approvalView}/>
            </div>
        </div>
    )
}